export enum ReportFilterEvents {
  ALL_SELECTED = '@reportFilter/ALL_SELECTED',
  FILTER = '@reportFilter/FILTER',
}
